import { SITE } from "@/constants/testIds";
import { Phone, Facebook, Linkedin } from "lucide-react";

const LOGO_URL = "/images/logo.png";
const PHONE = "541-890-3374";
const FB_URL = "https://www.facebook.com/profile.php?id=61578592467715";
const LINKEDIN_URL = "https://www.linkedin.com/in/mike-darck-8062561a/";

const links = [
  { label: "Home", href: "#hero" },
  { label: "About", href: "#about" },
  { label: "Lessons", href: "#lessons" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={SITE.footer}
      className="bg-brand-evergreen text-brand-cream"
    >
      <div className="border-t border-brand-cream/10">
        <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-12 md:px-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="The Spirit of Fishing"
                className="h-14 w-14"
              />
              <div>
                <div className="font-display text-xl">The Spirit of Fishing</div>
                <div className="text-xs uppercase tracking-[0.25em] text-brand-cream/60">
                  Rogue Valley · Southern Oregon
                </div>
              </div>
            </div>
            <p className="mt-6 max-w-sm font-display text-lg italic leading-relaxed text-brand-cream/85">
              Helping people discover the joy, confidence, and peace that come
              from learning to fly cast.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-brand-sand">
              Navigate
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              {links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-brand-cream/80 transition hover:text-brand-sand"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-brand-sand">
              Reach Mike
            </div>
            <a
              data-testid={SITE.footerPhone}
              href="tel:+15418903374"
              className="mt-5 inline-flex items-center gap-3 text-base text-brand-cream/90 transition hover:text-brand-sand"
            >
              <Phone className="h-4 w-4" />
              {PHONE}
            </a>
            <div className="mt-3">
              <a
                data-testid={SITE.footerLinkedin}
                href={LINKEDIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 text-base text-brand-cream/90 transition hover:text-brand-sand"
              >
                <Linkedin className="h-4 w-4" />
                LinkedIn
              </a>
            </div>
            <div className="mt-3">
              <a
                data-testid={SITE.footerFacebook}
                href={FB_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 text-base text-brand-cream/90 transition hover:text-brand-sand"
              >
                <Facebook className="h-4 w-4" />
                Facebook
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-brand-cream/10">
          <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-brand-cream/55 md:flex-row md:px-10">
            <span>
              <a
                href="/admin"
                aria-label="Admin sign-in"
                className="cursor-default text-brand-cream/55 no-underline hover:text-brand-cream/55 focus:outline-none"
              >
                ©
              </a>{" "}
              {year} The Spirit of Fishing. All rights reserved.
            </span>
            <span>Crafted with care on the rivers of Southern Oregon.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
